import { useState } from "react";
import { Layout } from "ui-components/Layout";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { SubmitButton } from "ui-components/Form";
import { formRender, initialValues, kpiTeamValidation } from "./kpi-team-schema";
import KPITeamInfo from "./components/KPITeamInfo";
import { useMutation } from "@tanstack/react-query";
import { Success, Error_ } from "ui-components/Alert";
import { createKPITeam } from "services/data.kpi.service";

function AddTeam() {
  const [alert, setAlert] = useState(null);
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  const createKPITeamMutation = useMutation(createKPITeam, {
    onSuccess: (data) => { console.log("✅ Mutation successful:", data);setAlert(<Success data={data} onChange={setAlert} />)},
    onError,
  });
  const form = useForm({ defaultValues: initialValues, resolver: yupResolver(kpiTeamValidation) });

  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = form;

  console.log("🔥 Validation Errors:", errors); // <--- add this

  const infoProps = { formRender, control, errors };
  const createStatus = createKPITeamMutation.status === "loading";
  const onSubmit = (data) => {
    console.log("📝 Form submitted with data:", data);

    const transformedData = {
      ...data,
      productivity: data.productivity?.value,
      user: data.user?.value,
    };

    createKPITeamMutation.mutate(transformedData, {
      onSuccess: () => {
        reset();
      },
    });
  };
  return (
    <Layout>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <KPITeamInfo {...infoProps} />
        <SubmitButton label="submit" disabled={createStatus} url="/kpi/kpi-team" />
      </form>
    </Layout>
  );
}

export default AddTeam;
